var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sessionColorSettings colorGroup"},[_c('ColorPicker',{attrs:{"default":''},on:{"updateColor":_vm.setColor}}),_vm._l((_vm.colors),function(color,index){return _c('button',{key:index,staticClass:"color",style:(`background-color:${color}`),on:{"click":function($event){return _vm.setColor(color)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }